import React, { SVGProps } from 'react';

export const EditNewIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.395 19.818 3.055.41-4.838 2.583c-.327.177-.716.28-1.128.28-.602 0-1.153-.22-1.575-.585l.003.003-1.866-1.614a.594.594 0 0 0-.707-.056l.002-.002-3.996 2.433-.938-1.539 4-2.432c.355-.22.786-.35 1.247-.35.601 0 1.15.221 1.572.586l-.004-.002 1.87 1.614c.188.162.456.19.675.076l2.632-1.404h-.005Zm-2.655-2.752L3.06 7.69a3.609 3.609 0 0 1-1.266-2.455v-.013c-.085-.964.22-1.92.847-2.656l.86-1.019a3.647 3.647 0 0 1 5.141-.43l-.005-.004 10.678 9.376c.517.44.907 1.026 1.116 1.688l2.07 6.643-6.896-.927a3.644 3.644 0 0 1-1.87-.831l.006.004v-.001ZM4.238 6.326 14.915 15.7c.255.216.583.36.93.408l4.096.55-1.23-3.944a1.857 1.857 0 0 0-.57-.86l-.003-.003L7.463 2.478a1.8 1.8 0 0 0-1.165-.424H6.29c-.566 0-1.073.254-1.412.654l-.002.003-.86 1.017a1.822 1.822 0 0 0-.427 1.352v-.008c.041.49.27.936.647 1.254h.002Z"
      />
    </svg>
  );
};
